package com.essntl.features.itinerary.ui.edit_itinerary_service

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.MessageSendType

sealed interface EditItineraryServiceNavigation {
    data object NavigateBack : EditItineraryServiceNavigation

    data object AddContact : EditItineraryServiceNavigation

    data class EditContact(val contact: ContactModel) : EditItineraryServiceNavigation

    data class AddItineraryServiceTask(
        val itineraryServiceId: String,
    ) : EditItineraryServiceNavigation

    data class EditTask(val taskId: String) : EditItineraryServiceNavigation

    data class EditClient(val client: ClientModel) : EditItineraryServiceNavigation

    data object SendMobileMessage : EditItineraryServiceNavigation

    data object ChangeSupplier : EditItineraryServiceNavigation

    data class SendMessage(
        val type: MessageSendType,
        val itineraryServices: List<ItineraryServiceModel> = emptyList(),
    ) : EditItineraryServiceNavigation
}